var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78076 7.51887L8.44675 9.20336L14 3.58838",
    stroke: "#29CC97",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1974 8.00005V12.0553C13.1974 12.3626 13.0753 12.6573 12.858 12.8746C12.6407 13.0919 12.346 13.214 12.0387 13.214H3.92818C3.62089 13.214 3.32618 13.0919 3.10889 12.8746C2.8916 12.6573 2.76953 12.3626 2.76953 12.0553V3.94478C2.76953 3.63749 2.8916 3.34278 3.10889 3.12549C3.32618 2.9082 3.62089 2.78613 3.92818 2.78613H10.3007",
    stroke: "#29CC97",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublished);
export default __webpack_public_path__ + "static/media/published.bad3fa45a4bbc25c523ef8949ba165fa.svg";
export { ForwardRef as ReactComponent };